import { requestConstantsMaker } from '../helper';

/**** 20200217 ****/
export const GET_ALL_APPLICATION_SESSION_REMARK = requestConstantsMaker('GET_ALL_APPLICATION_SESSION_REMARK');
export const GET_APPLICATION_SESSION_REMARKS_BY_STUDENT_ID = requestConstantsMaker('GET_APPLICATION_SESSION_REMARKS_BY_STUDENT_ID');
export const CREATE_APPLICATION_SESSION_REMARK = requestConstantsMaker('CREATE_APPLICATION_SESSION_REMARK');
export const UPDATE_APPLICATION_SESSION_REMARK = requestConstantsMaker('UPDATE_APPLICATION_SESSION_REMARK');
export const DELETE_APPLICATION_SESSION_REMARK = requestConstantsMaker('DELETE_APPLICATION_SESSION_REMARK');
/**** 20200217 ****/
